// SegmentedControl — a small mutually-exclusive switch between a fixed set of
// options (e.g. the Billing page's Monthly|Yearly toggle). Same dark-theme
// tokens as Button/Card; the selected segment gets the amber treatment the
// primary Button uses. Exposed as a radiogroup so screen readers announce the
// options as one choice.
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  'aria-label': ariaLabel,
}: {
  options: ReadonlyArray<{ value: T; label: string }>
  value: T
  onChange: (value: T) => void
  'aria-label': string
}) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className="inline-flex items-center gap-0.5 rounded-md border border-line-strong bg-surface p-0.5"
    >
      {options.map((opt) => {
        const selected = opt.value === value
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.value)}
            className={`rounded px-3 py-1 text-sm font-medium transition-colors ${
              selected
                ? 'bg-glow-600 text-ink'
                : 'text-muted hover:bg-surface-2 hover:text-cream'
            }`}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
